export function getLogoutBaseUrl() {
  const url = window.location.href.toLowerCase();
  console.debug('window.location.href url: ' + url);
  if (
    url.indexOf('nvhuswebclienttest.azurewebsites.net') > 0 ||
    url.indexOf('test.naturfagsmaraton.dk') > 0 ||
    url.indexOf('test.sciencedysten.dk') > 0
  ) {
    return 'https://et-broker.unilogin.dk/auth/realms/broker/protocol/openid-connect/logout';
  } else if (
    url.indexOf('nvhuswebclientdemo.azurewebsites.net') > 0 ||
    url.indexOf('demo.naturfagsmaraton.dk') > 0 ||
    url.indexOf('demo.sciencedysten.dk') > 0
  ) {
    return 'https://et-broker.unilogin.dk/auth/realms/broker/protocol/openid-connect/logout';
  } else if (
    url.indexOf('nvhuswebclientdrift.azurewebsites.net') > 0 ||
    url.indexOf('naturfagsmaraton.dk') > 0 ||
    url.indexOf('sciencedysten.dk') > 0
  ) {
    return 'https://broker.unilogin.dk/auth/realms/broker/protocol/openid-connect/logout';
  } else {
    return 'https://et-broker.unilogin.dk/auth/realms/broker/protocol/openid-connect/logout';
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/infrastructure/LogoutUrlResolver.ts